import React, { useEffect, useState } from "react";
import { MdOutlineSell } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../utills";
import { LiaCarSideSolid } from "react-icons/lia";
import logo from "../../assets/images/msm-motors-black-logo.png";
import { HiMenuAlt1 } from "react-icons/hi";
import CustomDropdown from "../../components/customDropDown";
const Header = ({
  landing,
  pages,
  carBrands,
  carModels,
  cities,
  setOpenModal,
  setOpenModal3,
  setOpenModal4,
  isScrolled,
  bikes
}) => {
  // console.log("carBrands prop", carBrands);

  const token = localStorage.getItem("access_token");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isBrandCarOpen, setIsBrandCarOpen] = useState(false);
  const [isPopularCarOpen, setIsPopularCarOpen] = useState(false);
  const [isCityCarOpen, setIsCityCarOpen] = useState(false);

  const [isBrandCarNewOpen, setIsBrandCarNewOpen] = useState(false);
  const [isPopularCarNewOpen, setIsPopularCarNewOpen] = useState(false);
  const [isCityCarNewOpen, setIsCityCarNewOpen] = useState(false);
  const [isBikesOpen,setIsBikesOpen]=useState(false)
  const user_id = localStorage.getItem("user_id");

  // const [carBrands, setCarBrands] = useState();
  // const [cities, setCities] = useState();
  // const [carModels, setCarModels] = useState();
  const navigate = useNavigate();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleBrandCar = (id) => {
    if (id == "1") {
      setIsBrandCarOpen(!isBrandCarOpen);
      setIsPopularCarOpen(false);
      setIsCityCarOpen(false);
      setIsBrandCarNewOpen(false);
      setIsPopularCarNewOpen(false);
      setIsCityCarNewOpen(false);
    } else if (id == "2") {
      setIsPopularCarOpen(!isPopularCarOpen);
      setIsBrandCarOpen(false);
      setIsCityCarOpen(false);
      setIsBrandCarNewOpen(false);
      setIsPopularCarNewOpen(false);
      setIsCityCarNewOpen(false);
    } else if (id == "3") {
      setIsCityCarOpen(!isCityCarOpen);
      setIsPopularCarOpen(false);
      setIsBrandCarOpen(false);
      setIsBrandCarNewOpen(false);
      setIsPopularCarNewOpen(false);
      setIsCityCarNewOpen(false);
    } else if (id == "4") {
      setIsCityCarOpen(false);
      setIsPopularCarOpen(false);
      setIsBrandCarOpen(false);
      setIsBrandCarNewOpen(!isBrandCarNewOpen);
      setIsPopularCarNewOpen(false);
      setIsCityCarNewOpen(false);
    } else if (id == "5") {
      setIsCityCarOpen(false);
      setIsPopularCarOpen(false);
      setIsBrandCarOpen(false);
      setIsBrandCarNewOpen(false);
      setIsPopularCarNewOpen(!isPopularCarNewOpen);
      setIsCityCarNewOpen(false);
    } else {
      setIsCityCarNewOpen(false);
      setIsPopularCarOpen(false);
      setIsBrandCarOpen(false);
      setIsBrandCarNewOpen(false);
      setIsPopularCarNewOpen(false);
      setIsCityCarNewOpen(!isCityCarNewOpen);
    }
  };
  const toggleBikes = () => {
      setIsBikesOpen(!isBikesOpen);
  };

  const toggleNewCar = () => {
    setIsPopularCarOpen(!isPopularCarOpen);
  };

  // const fetchCarBrands = async () => {
  //   try {
  //     const res = await axios.get(baseUrl + "get_car_makers/", {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     setCarBrands(res?.data);
  //     // console.log("car brands", res);
  //   } catch (error) {
  //     console.error("error:", error);
  //   }
  // };
  // const fetchCarModels = async () => {
  //   try {
  //     const res = await axios.get(baseUrl + "car_models", {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     setCarModels(res?.data);
  //     // console.log("popular car models:", res);
  //   } catch (error) {
  //     console.error("error:", error);
  //   }
  // };
  // const fetchCities = async () => {
  //   try {
  //     const res = await axios.get(baseUrl + "cities/", {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     setCities(res?.data);
  //     // console.log("citiess", res);
  //   } catch (error) {
  //     console.error("error:", error);
  //   }
  // };
  useEffect(() => {
    // fetchCarBrands();
    // fetchCarModels();
    // fetchCities();
  }, []);
  // console.log("carModels:", carModels);
 const items2 = [
    {
      label: (
       
          <p
            style={{ fontWeight: 500 }}
            onClick={() => {
              if (token && user_id) {
                setOpenModal(true);
              } else {
                navigate("/login");
              }
            }}
          >
            Post a Car
          </p>
       
      ),
      key: "1",
    },
    {
      label: (
      
         
          <p
            style={{ fontWeight: 500 }}
            onClick={() => {
              if (token && user_id) {
                setOpenModal4(true);
              } else {
                navigate("/login");
              }
            }}
          >
            Post a Bike
          </p>
      
      ),
      key: "2",
    },
  ];
  return (
    <header className="bg-transparent border-none border-t border-1 border-lightgray-500">
      {/* Mobile Menu Button */}
      <div className="lg:hidden flex items-center justify-between p-4">
        <button
          type="button"
          className={`-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 ${
            landing ? "text-[white]" : "text-gray"
          }`}
          onClick={toggleMenu}
        >
          <span className="sr-only">Open main menu</span>
          <HiMenuAlt1 style={{ fontSize: "20px", marginRight: "5px" }} />{" "}
          <span className="font-[500]">MENU</span>
        </button>
      </div>

      {/* Mobile Menu (visible only when isMenuOpen is true) */}
      {isMenuOpen && (
        <div className="lg:hidden" role="dialog" aria-modal="true">
          <div className="fixed inset-0 z-10"></div>
          <div className="fixed inset-y-0 left-0 z-10 w-[300px] overflow-y-auto bg-white border-r border-r-1 border-[lightgray] px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <div
                className={`font-bold flex items-center gap-1 ${
                  landing ? "text-white" : ""
                }`}
              >
                {/* <LiaCarSideSolid className="text-[45px] text-[black] " /> */}
                <img width="110px" src={logo} alt="" />
                {/* <div className="block">
                  <p className="text-[16px] text-[black]">MSM</p>
                  <p className="text-[20px] text-customGreen mt-[-13px]">
                    MOTORS
                  </p>
                </div> */}
              </div>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                onClick={toggleMenu}
              >
                <span className="sr-only">Close menu</span>
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  {/* Used Car Section */}
                  <div className="flex justify-between items-center">
                    <a
                      href="#"
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900"
                    >
                      USED CAR
                    </a>
                  </div>

                  <div>
                    <div>
                      <div className="flex justify-between items-center">
                        <p className="font-bold text-[#b5b5b5] text-[15px] leading-7">
                          Browse by Brand
                        </p>
                        <p
                          onClick={() => toggleBrandCar(1)}
                          className="cursor-pointer"
                        >
                          {isBrandCarOpen ? "-" : "+"}
                        </p>
                      </div>
                      <div className="ps-[14px]">
                        {isBrandCarOpen && (
                          <>
                            {carBrands?.slice(0, 10)?.map((brand, index) => (
                              <div
                                onClick={() => {
                                  navigate("/car-listing", {
                                    state: {
                                      maker_id: brand?.id,
                                      category_id: 1,
                                      name: brand?.car_maker,
                                    },
                                  });
                                  setIsMenuOpen(false);
                                }}
                                key={index}
                              >
                                <p className=" block border-b py-2 text-[14px] font-semibold leading-7 text-gray-900">
                                  {brand?.car_maker} ({brand?.post_count})
                                </p>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </div>

                    <div>
                      <div className="flex justify-between items-center">
                        <p className="font-bold text-[#b5b5b5] text-[15px] leading-7">
                          Popular Models
                        </p>
                        <p
                          onClick={() => toggleBrandCar(2)}
                          className="cursor-pointer"
                        >
                          {isPopularCarOpen ? "-" : "+"}
                        </p>
                      </div>
                      <div className="ps-[14px]">
                        {isPopularCarOpen && (
                          <>
                            {carModels?.slice(0, 10)?.map((model, index) => (
                              <div
                                onClick={() => {
                                  setIsMenuOpen(false);

                                  navigate("/car-listing", {
                                    state: {
                                      model_id: model?.id,
                                      modelName: model?.model_name,
                                      category_id: 1,
                                    },
                                  });
                                }}
                                key={index}
                              >
                                <a
                                  href="#"
                                  className=" block border-b py-2 text-[14px] font-semibold leading-7 text-gray-900"
                                >
                                  {model?.model_name}
                                </a>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </div>

                    <div>
                      <div className="flex justify-between items-center">
                        <p className="font-bold text-[#b5b5b5] text-[15px] leading-7">
                          Browse by City
                        </p>
                        <p
                          onClick={() => toggleBrandCar(3)}
                          className="cursor-pointer"
                        >
                          {isCityCarOpen ? "-" : "+"}
                        </p>
                      </div>
                      <div className="ps-[14px]">
                        {isCityCarOpen && (
                          <>
                            {cities?.slice(0, 10)?.map((city, index) => (
                              <div
                                onClick={() => {
                                  setIsMenuOpen(false);

                                  navigate("/car-listing", {
                                    state: {
                                      city_id: city?.id,
                                      category_id: 1,
                                    },
                                  });
                                }}
                                key={index}
                              >
                                <a
                                  href="#"
                                  className=" block border-b py-2 text-[14px] font-semibold leading-7 text-gray-900"
                                >
                                  {city?.name} ({city?.post_count})
                                </a>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* New Car Section */}

                  <div className="flex justify-between items-center">
                    <a
                      href="#"
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900"
                    >
                      NEW CAR
                    </a>
                  </div>

                  <div>
                    <div>
                      <div className="flex justify-between items-center">
                        <p className="font-bold text-[#b5b5b5] text-[15px] leading-7">
                          Browse by Brand
                        </p>
                        <p
                          onClick={() => toggleBrandCar(4)}
                          className="cursor-pointer"
                        >
                          {isBrandCarNewOpen ? "-" : "+"}
                        </p>
                      </div>
                      <div className="ps-[14px]">
                        {isBrandCarNewOpen && (
                          <>
                            {carBrands?.slice(0, 10)?.map((brand, index) => (
                              <div
                                onClick={() => {
                                  setIsMenuOpen(false);
                                  navigate("/car-listing", {
                                    state: {
                                      maker_id: brand?.id,
                                      category_id: 2,
                                      name: brand?.car_maker,
                                    },
                                  });
                                }}
                                key={index}
                              >
                                <a
                                  href="#"
                                  className=" block border-b py-2 text-[14px] font-semibold leading-7 text-gray-900"
                                >
                                  {brand?.car_maker} ({brand?.post_count})
                                </a>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </div>

                    <div>
                      <div className="flex justify-between items-center">
                        <p className="font-bold text-[#b5b5b5] text-[15px] leading-7">
                          Popular Models
                        </p>
                        <p
                          onClick={() => toggleBrandCar(5)}
                          className="cursor-pointer"
                        >
                          {isPopularCarNewOpen ? "-" : "+"}
                        </p>
                      </div>
                      <div className="ps-[14px]">
                        {isPopularCarNewOpen && (
                          <>
                            {carModels?.slice(0, 10)?.map((model, index) => (
                              <div
                                onClick={() => {
                                  setIsMenuOpen(false);
                                  navigate("/car-listing", {
                                    state: {
                                      model_id: model?.id,
                                      modelName: model?.model_name,
                                      category_id: 2,
                                    },
                                  });
                                }}
                                key={index}
                              >
                                <a
                                  href="#"
                                  className=" block border-b py-2 text-[14px] font-semibold leading-7 text-gray-900"
                                >
                                  {model?.model_name}
                                </a>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </div>

                    <div>
                      <div className="flex justify-between items-center">
                        <p className="font-bold text-[#b5b5b5] text-[15px] leading-7">
                          Browse by City
                        </p>
                        <p
                          onClick={() => toggleBrandCar(6)}
                          className="cursor-pointer"
                        >
                          {isCityCarNewOpen ? "-" : "+"}
                        </p>
                      </div>
                      <div className="ps-[14px]">
                        {isCityCarNewOpen && (
                          <>
                            {cities?.slice(0, 10)?.map((city, index) => (
                              <div
                                onClick={() => {
                                  setIsMenuOpen(false);
                                  navigate("/car-listing", {
                                    state: {
                                      city_id: city?.id,
                                      category_id: 2,
                                    },
                                  });
                                }}
                                key={index}
                              >
                                <a
                                  href="#"
                                  className=" block border-b py-2 text-[14px] font-semibold leading-7 text-gray-900"
                                >
                                  {city?.name} ({city?.post_count})
                                </a>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <div>
                  <div className="flex justify-between items-center">
                        <p className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900">
                          BIKES
                        </p>
                       
                      </div>
                      <div>
                        {/* {isBikesOpen && ( */}
                          <>
                             {bikes?.map((item,index) => (
                      <div
                        key={index}
                        className="font-bold text-[#b5b5b5] text-[15px] leading-7"
                        onClick={() => navigate(`/${item?.path}`)}
                      >
                        <p className="">{item?.name}</p>
                      </div>
                    ))}
                          </>
                      {/* //   )} */}
                       </div>
            
              </div>

                  <a
                    href="#"
                    className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900"
                  >
                    CONTACT US
                  </a>
                </div>

                <div className="py-6">
                <CustomDropdown
              style={{
                background: "transparent",
                color: landing ? "white" : "black",
                boxShadow: "none",
              }}
              items={items2}
            >
                  <button
                    // onClick={() => {
                    //   if (token) {
                    //     setOpenModal(true);
                    //   } else {
                    //     setOpenModal3(true);
                    //   }
                    // }}
                    className="hover:text-green-500 text-black flex items-center gap-[5px] border-none
                    -mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900"
                  >
                    <MdOutlineSell className="text-green-500" />
                    SELL WITH US
                  </button>
                  </CustomDropdown>
                </div>
              </div>
             
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
